<template>
  <h3>Авторизация...</h3>
</template>

<script>
  import Mgr from '../../services/SecureService'
    export default {
        name: "Callback",
      data(){
          return {
            mgr:new Mgr()
          }
      },
      mounted(){
          var vm= this;
          this.mgr.signinRedirectCallback(window.location).then(function (user) {
            vm.$store.commit("userData/setCurUser", user);
            vm.$store.commit("userData/setSignedIn", true);
            vm.$router.push({ name: 'Main' })
          }).catch(function (e) {
            console.error(e);
          });
      }

    }
</script>

<style scoped>

</style>
